import type { ProjectReviewEligibility } from "@shared/types";
import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/query-keys";
import { getProjectReviewEligibility } from "@/services/reviews-api.service";

/**
 * Who the homeowner may review on a project, and what they already wrote.
 * `enabled` should be true only for a completed project: the server answers
 * "cannot review" for any other, so there is nothing to ask before then.
 */
export function useProjectReviewEligibility(
	projectId: string,
	enabled: boolean,
) {
	return useQuery<ProjectReviewEligibility>({
		queryKey: queryKeys.reviews.projectEligibility(projectId),
		enabled,
		queryFn: async () => {
			const result = await getProjectReviewEligibility(projectId);
			if (!result.success || !result.data) {
				throw new Error(result.error ?? "Failed to load review eligibility");
			}
			return result.data;
		},
	});
}
